// Mirrors FoodStorm.DeviceMonitoringCore.Abstractions.Models.DeviceType.
// The API serializes the enum as its integer ordinal (Newtonsoft default),
// so the numeric values must match the C# declaration order.
export enum DeviceType {
  Kiosk = 0,
  Printer = 1,
  Kds = 2,
  PaymentTerminal = 3,
}

export interface OfflineDevice {
  deviceType: DeviceType
  lastSeenUtc: string | null
  deviceName: string | null
  departmentName: string | null
}

export interface SiteHealth {
  offlineDevices: OfflineDevice[]
}

export const deviceTypeLabel = (type: DeviceType): string => {
  switch (type) {
    case DeviceType.Kiosk:
      return 'Kiosk'
    case DeviceType.Printer:
      return 'Printer'
    case DeviceType.Kds:
      return 'KDS'
    case DeviceType.PaymentTerminal:
      return 'Payment Terminal'
    default:
      return 'Device'
  }
}
